import React from 'react';
import Styles from './Checkbox.module.css';

const CustomeCheckBox = ({ loc, handleLocation, i }) => {
    return (
        <label className={Styles.customCheckbox}>
            <input
                className={Styles.checkBoxInput}
                type="checkbox"
                id={loc.name}
                name={loc.name}
                value={loc.value}
                checked={loc.ischecked}
                onChange={(e) => handleLocation(e, i)}
            />
            <span className={Styles.checkmark}></span>
            {loc.label}
        </label>
    );
};

export default CustomeCheckBox;
